const AddTransaction = () => {
    return <h3>new transaction</h3>
}

export default  AddTransaction;